introParallax($(window));

function introParallax($win) {
	if ($('.js-parallax').length) {
		$win.on('load scroll', function() {
			const winT = $win.scrollTop();
			const winH = $win.height();
			const introPos = Math.min(winT / 3, winH);
			$('.js-parallax').css({
				transform: `translateY(${introPos}px)`
			});
		});
	}
}
